import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGroupAddFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 4.99613C12.8282 6.3243 12.8282 8.67183 11.5 10C10.1718 11.3282 7.82817 11.3282 6.5 10C5.17183 8.67183 5.17183 6.3243 6.5 4.99613C7.82817 3.66796 10.1718 3.66796 11.5 4.99613Z",
			fill: "#111827"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 18C3 15.791 4.791 14 7 14H11C11.5672 14 12.1069 14.1181 12.5957 14.331C11.8723 15.7958 11.8971 17.3873 12 18H3Z",
			fill: "#111827"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 4.5C17.381 4.5 18.5 5.619 18.5 7C18.5 8.381 17.381 9.5 16 9.5M3 18C3 15.791 4.791 14 7 14H11C11.5672 14 12.1069 14.1181 12.5957 14.331C11.8723 15.7958 11.8971 17.3873 12 18H3ZM11.5 4.99613C12.8282 6.3243 12.8282 8.67183 11.5 10C10.1718 11.3282 7.82817 11.3282 6.5 10C5.17183 8.67183 5.17183 6.3243 6.5 4.99613C7.82817 3.66796 10.1718 3.66796 11.5 4.99613Z",
			stroke: "#111827",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 15V19M19 17H15M17 22C14.239 22 12 19.762 12 17C12 14.296 14.3 11.997 17.004 12C19.764 12.002 22 14.24 22 17C22 19.761 19.762 22 17 22Z",
			stroke: "#111827",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgGroupAddFilled);
export default ForwardRef;
